__turbopack_context__.v({
  "bolder": "AboutUsTextModule-module__uOL3NW__bolder",
  "container": "AboutUsTextModule-module__uOL3NW__container",
});
